import { gql } from "graphql-tag";
export const GETBLOG = gql`
  query MyQuery {
    posts {
      author {
        name
      }
      content {
        text
      }
      coverImage {
        url
      }
      datePublished
      slug
      title
      description
      id
      category {
        name
      }
    }
  }
`;

export const GETSLUG = gql`
  query MyQuery($slug: String!) {
    post(where: { slug: $slug }) {
      title
      slug
      coverImage {
        url
      }
      content {
        raw
      }
      author {
        name
      }
      description
      datePublished
      category {
        name
      }
    }
  }
`;

export const GETNEWSDETS = gql`
  query MyQuery($slug: String!) {
    newsPost(where: { slug: $slug }) {
      newsHeading
      slug
      newsDescription
      coverImage {
        url
      }
      newsContent {
        raw
      }
    
    }
  }
`;

export const GETCATEG = gql`
  query MyQuery($category: String!) {
    posts(where: { category: { name: $category } }) {
      title
      slug
      datePublished
      coverImage {
        url
      }
      category {
        name
        id
      }
    }
  }
`;

export const GETNEWS = gql`
  query MyQuery {
    newsPosts {
      newsContent {
        raw
      }
      coverImage {
        url
      }
      newsDescription
      newsHeading
      publishedAt
      slug
      author {
        ... on Author {
          name
        }
      }
    }
  }
`;
